import { type Optional, typeUtils } from '@festina-life/core'

import { type BranchDetailsTabKey, isBranchDetailsTabKey } from './types'

/**
 * Navigation state carried through React Router when switching to a workspace or branch,
 * used to auto-select a specific details tab on arrival (e.g. after pulling a
 * changeset into a new workspace we want to land on the "Changes" tab).
 */
export type BranchDetailsNavigationState = {
  initialTab: BranchDetailsTabKey
}

export const getBranchDetailsNavigationState = (
  state: unknown,
): Optional<BranchDetailsNavigationState> => {
  if (!typeUtils.hasField(state, 'initialTab')) {
    return undefined
  }

  const { initialTab } = state

  if (
    !initialTab ||
    typeof initialTab !== 'string' ||
    !isBranchDetailsTabKey(initialTab)
  ) {
    return undefined
  }

  return { initialTab }
}
